import { render, staticRenderFns } from "./PhotoBooks.vue?vue&type=template&id=1263940d&scoped=true"
import script from "./PhotoBooks.vue?vue&type=script&lang=js"
export * from "./PhotoBooks.vue?vue&type=script&lang=js"
import style0 from "./PhotoBooks.vue?vue&type=style&index=0&id=1263940d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1263940d",
  null
  
)

export default component.exports